import { useSSE } from "./use-sse";
import { useToast } from "./use-toast";
import MilestoneAlert from "../components/milestones/MilestoneAlert";
import Title from "../components/Title";

export default function useMilestoneNotifications() {
  const showToast = useToast();
  useSSE("notification", (notification) => {
    if (notification.payload.event !== "team_milestone_created") return;

    const { milestone, contact, user } = notification.payload;

    showToast(
      <MilestoneAlert active horizontal sound>
        <Title>
          {milestone.name}
          <small>
            from {user.firstName} {user.lastName} (for {contact.firstName}{" "}
            {contact.lastName})
          </small>
        </Title>
      </MilestoneAlert>,
      {
        white: true,
      }
    );
  });
}
